import {createRouter, createWebHistory} from 'vue-router'

const routerHistory = createWebHistory()

// import Vpage from '../view/page.vue'
import Vlogin from '../view/login.vue'
// 定义路由
const routes = [
    {
        path: '/',
        name: 'Vlogin',
        component: Vlogin
    },
   
]

// 创建路由器
const router = createRouter({
    history: routerHistory,
    routes: routes
})
router.beforeEach((to,form,next)=>{
    document.title = "深圳悦乐世界科技有限公司"; // 使用路由的meta字段来设置标题
  next();
})

 export default router